import { createFileRoute } from '@tanstack/react-router'

import { WorkItemExecutionPage } from '@/pages/execution/WorkItemExecution.page'

export const Route = createFileRoute(
  '/_auth/$companyId/spaces/$spaceId/projects/$projectId/batches_/work-items_/$workItemId/execution',
)({
  component: WorkItemExecutionPage,
  loader: () => ({ breadcrumbTitle: 'Execution' }),
})
